import { useHasUserFlag } from '.';
import { FLAG_COMMONSKU_PAYMENTS } from '../components/admin-new/CreditCardIntegration';
import { ICompanyData } from '../interfaces/CompanyData';
import { useCompanyData } from '../redux/hooks/company_data';

type CommonskuPaymentsCompanyData = Pick<ICompanyData, 'commonsku_payments'>;

export default function useCommonskuPaymentsCreditCardFeeCap(
    companyData?: CommonskuPaymentsCompanyData,
): boolean {
    const hasCommonskuPaymentsFlag = useHasUserFlag(FLAG_COMMONSKU_PAYMENTS);
    const reduxCompanyData = useCompanyData();
    const commonskuPayments = companyData?.commonsku_payments ?? reduxCompanyData?.commonsku_payments ?? 0;

    return hasCommonskuPaymentsFlag && commonskuPayments === 1;
}
